export const FORGOT_PASSWORD_EVENTS = {
    SELECT_LOGIN_FORGOT_PASSWORD: "select_login_forgot_password",
    VIEW_FORGOT_PASSWORD_SCREEN: "view_forgot_password_screen",
    SELECT_FORGOT_PASSWORD_SEND_ME_THE_RECOVERY_LINK: "select_forgot_password_send_me_the_recovery_link",
    VIEW_FORGOT_PASSWORD_RECOVERY_EMAIL_SENT_SCREEN: "view_forgot_password_recovery_email_sent_screen",
    SELECT_FORGOT_PASSWORD_DONE_AFTER_SEND_RECOVERY_LINK: "select_forgot_password_done_after_send_recovery_link"
} as const;